{
	"title": "Fakturaer",
	"buttonShowMoreInvoicesTitle": "Vis flere fakturaer",
	"invoicesTableHeaders": {
		"date": "Dato",
		"invoiceNumber": "Fakturanummer",
		"deliveredQuantity": "Levert mengde",
		"bundledCarbonSavings": "Samlede karbonreduksjoner",
		"transactionId": "Transaksjons-ID"
	},
	"errorMessage": "Kunne ikke laste inn fakturaer"
}
